var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataConnectorAlerts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#data_connector_alerts_svg__clip0_1263_1398)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.512 21c-1.401 0-2.565-1.08-2.72-2.472h5.475C12.089 19.92 10.925 21 9.512 21zM19 15.456c0 .864-.677 1.548-1.532 1.548H1.532A1.529 1.529 0 010 15.456c0-.864.677-1.548 1.532-1.548 0 0 1.84 0 1.84-1.86V7.716h.036c0-.096-.035-.216-.035-.312 0-3 2.113-5.496 4.892-6.06v-.12c0-.684.546-1.236 1.223-1.236s1.223.552 1.223 1.236v.12c2.779.552 4.893 3.06 4.893 6.06 0 .096 0 .216-.036.312h.036v4.332c0 1.86 1.84 1.86 1.84 1.86.891 0 1.556.684 1.556 1.548z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "data_connector_alerts_svg__clip0_1263_1398"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h19v21H0z"
  })))));
}
export default SvgDataConnectorAlerts;